export const data = {
    disabilityChildren: `Для ухода за ребенком-инвалидом один из родителей может оформить до 4-х дополнительных дней отдыха в месяц либо взять подряд не более 24 дней при наличии накопленных дней за прошедшие периоды календарного года.
        Обращаем внимание: для закрытия заявки будет необходимо предоставить оригиналы документов в ОЦО (после получения соответствующего уведомления).`,
    bloodDonation: `В связи со сдачей крови и ее компонентов возможно оформить до 2-х дополнительных дней отдыха.
        Необходимо приложить: скан-копию справки о сдаче крови и ее компонентов.`,
}
